import {addremovefilters} from "../actions";

export const barChartDataDailyTraffic = [
    {
        name: "Daily Traffic",
        data: [20, 30, 40, 20, 45, 50, 30],
    },
];

export const barChartOptionsDailyTraffic = {
    chart: {
        toolbar: {
            show: false,
        },
    },
    tooltip: {
        style: {
            fontSize: "12px",
            fontFamily: undefined,
            backgroundColor: "#000000"
        },
        onDatasetHover: {
            style: {
                fontSize: "12px",
                fontFamily: undefined,
            },
        },
        theme: "dark",
    },
    xaxis: {
        categories: ["00", "04", "08", "12", "14", "16", "18"],
        show: false,
        labels: {
            show: true,
            style: {
                colors: "#A3AED0",
                fontSize: "14px",
                fontWeight: "500",
            },
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        show: false,
        color: "black",
        labels: {
            show: true,
            style: {
                colors: "#CBD5E0",
                fontSize: "14px",
            },
        },
    },
    grid: {
        show: false,
        strokeDashArray: 5,
        yaxis: {
            lines: {
                show: true,
            },
        },
        xaxis: {
            lines: {
                show: false,
            },
        },
    },
    fill: {
        type: "gradient",
        gradient: {
            type: "vertical",
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            colorStops: [
                [
                    {
                        offset: 0,
                        color: "#4318FF",
                        opacity: 1,
                    },
                    {
                        offset: 100,
                        color: "rgba(67, 24, 255, 1)",
                        opacity: 0.28,
                    },
                ],
            ],
        },
    },
    dataLabels: {
        enabled: false,
    },
    plotOptions: {
        bar: {
            borderRadius: 10,
            columnWidth: "40px",
        },
    },
};

export const pieChartOptions = {
    labels: ["Solved", "Unresolved"],
    colors: ["#6AD2FF", "#FF9A8B"],
    chart: {
        width: "50px",
        events: {
            dataPointSelection: (event, chartContext, config) => {

                if (['undecided', 'solved', 'unresolved'].includes(config.w.config.labels[config.dataPointIndex].toLowerCase())) {
                    let value = "Null";

                    if(config.w.config.labels[config.dataPointIndex].toLowerCase() === "solved") {
                        value = "True";
                    }else if(config.w.config.labels[config.dataPointIndex].toLowerCase() === "unresolved") {
                        value = "False";
                    }

                    addremovefilters({filtername: "BotSolved", value: value})
                }


                if (['transferred', 'not transferred'].includes(config.w.config.labels[config.dataPointIndex].toLowerCase())) {
                    let value = "Null";

                    if(config.w.config.labels[config.dataPointIndex].toLowerCase() === "transferred") {
                        value = "True";
                    }else if(config.w.config.labels[config.dataPointIndex].toLowerCase() === "not transferred") {
                        value = "False";
                    }

                    addremovefilters({filtername: "transfer_to_agent", value: value});
                }
            }
        }
    },
    states: {
        hover: {
            filter: {
                type: "none",
            },
        },
    },
    legend: {
        show: false,
    },
    dataLabels: {
        enabled: false,
    },
    hover: {mode: null},
    plotOptions: {
        donut: {
            expandOnClick: false,
            donut: {
                labels: {
                    show: false,
                },
            },
        },
    },
    fill: {
        colors: ["#6AD2FF", "#FF9A8B"],
    },
    tooltip: {
        enabled: true,
        theme: "dark",
        style: {
            fontSize: "12px",
            fontFamily: undefined,
            backgroundColor: "#000000"
        },
    },
};

export const pieChartData = [63, 25, 12];

export const barChartDataWeeklyRevenue = [
    {
        "name": "PRODUCT A",
        "data": [400, 370, 330, 390, 320, 350, 360, 320, 380],
        "color": "#6AD2Fa",
    },
    {
        name: "PRODUCT B",
        data: [400, 370, 330, 390, 320, 350, 360, 320, 380],
        color: "#4318FF",
    },
    {
        name: "PRODUCT C",
        data: [400, 370, 330, 390, 320, 350, 360, 320, 380],
        color: "#EFF4FB",
    },
];

export const barChartOptionsWeeklyRevenue = {
    chart: {
        type: 'bar',
        toolbar: {
            show: false,
        },
        events: {
            click(event, chartContext, opts) {
                let data = opts.config.series[opts.seriesIndex].data[opts.dataPointIndex];
                if(data.x.indexOf('_') > -1){
                    addremovefilters({filtername: "functions", value: data.x})
                }else{
                    addremovefilters({filtername: "Category", value: data.x})
                }

            }
        }

    },
    // colors:['#ff3322','#faf']
    tooltip: {
        style: {
            fontSize: "12px",
            fontFamily: undefined,
            backgroundColor: "#000000"
        },
        theme: 'dark',
        onDatasetHover: {
            style: {
                fontSize: "12px",
                fontFamily: undefined,
            },
        },
    },
    xaxis: {
        show: false,
        labels: {
            show: true,
            style: {
                colors: "#A3AED0",
                fontSize: "14px",
                fontWeight: "500",
            },
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        show: true,
        color: "black",
        labels: {
            show: true,
            style: {
                colors: "#A3AED0",
                fontSize: "14px",
                fontWeight: "500",
            },
        },
    },

    grid: {
        borderColor: "rgba(163, 174, 208, 0.3)",
        show: true,
        yaxis: {
            lines: {
                show: false,
                opacity: 0.5,
            },
        },
        row: {
            opacity: 0.5,
        },
        xaxis: {
            lines: {
                show: false,
            },
        },
    },
    fill: {
        type: "solid",
        colors: ["#5E37FF", "#6AD2FF", "#FF6F91", "#FF9A8B"],
    },
    legend: {
        show: false,
    },
    colors: ["#5E37FF", "#6AD2FF", "#FF6F91", "#FF9A8B"],
    dataLabels: {
        enabled: false,
    },
    plotOptions: {
        bar: {
            borderRadius: 10,
            columnWidth: "20px",
            distributed: true
        },
    },
};


export const lineChartDataTotalSpent = [
    {
        name: "Revenue",
        data: [50, 64, 48, 66, 49, 68],
        color: "#4318FF",
    },
    {
        name: "Profit",
        data: [30, 40, 24, 46, 20, 46],
        color: "#6AD2FF",
    },
];

export const lineChartOptionsTotalSpent = {
    legend: {
        show: false,
    },

    theme: {
        mode: "light",
    },
    chart: {
        type: "line",
        zoom: {
            enabled: false,
        },
        toolbar: {
            show: false,
        },
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        curve: "smooth",
    },
    tooltip: {
        style: {
            fontSize: "12px",
            fontFamily: undefined,
            backgroundColor: "#000000"
        },
        theme: 'dark',
        x: {
            format: "dd/MM/yy HH:mm",
        },
    },
    grid: {
        show: false,
    },
    xaxis: {
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        labels: {
            rotate: 0,
            style: {
                colors: "#A3AED0",
                fontSize: "12px",
                fontWeight: "500",
            },
        },
        type: "text",
        range: undefined,
        categories: [],
    },

    yaxis: {
        show: true,
    },
};
